import { useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface SearchBarProps {
  onSearch: (query: string, type: 'pizzeria' | 'pizza' | 'location') => void;
}

export default function SearchBar({ onSearch }: SearchBarProps) {
  const [searchType, setSearchType] = useState<'pizzeria' | 'pizza'>('pizzeria');
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // If query contains location keywords, use location type
    const locationKeywords = ['lombardia', 'veneto', 'lazio', 'roma', 'milano', 'napoli', 'firenze', 'bologna', 'torino'];
    const isLocation = locationKeywords.some(keyword => 
      query.toLowerCase().includes(keyword.toLowerCase())
    );
    
    onSearch(query, isLocation ? 'location' : searchType);
  };

  return (
    <div className="w-full px-4">
      <form onSubmit={handleSubmit} className="max-w-full mx-auto bg-white rounded-2xl shadow-lg">
        <div className="flex items-center p-2">
          {/* Toggle Buttons */}
          <div className="flex bg-gray-100 rounded-lg p-1 mr-4">
            <button
              type="button"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                searchType === 'pizzeria'
                  ? 'bg-pizzaveg text-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
              onClick={() => setSearchType('pizzeria')}
            >
              Pizzerie
            </button>
            <button
              type="button"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                searchType === 'pizza'
                  ? 'bg-pizzaveg text-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
              onClick={() => setSearchType('pizza')}
            >
              Pizze
            </button>
          </div>

          {/* Search Input */}
          <div className="flex-1 relative">
            <input
              type="text"
              className="w-full pl-10 pr-4 py-2 rounded-xl border-2 border-gray-100 focus:border-pizzaveg focus:ring-2 focus:ring-pizzaveg focus:ring-opacity-20 transition-colors duration-200 bg-gray-50 text-gray-800 placeholder-gray-400"
              placeholder={`Cerca ${searchType === 'pizzeria' ? 'pizzerie' : 'pizze'} per nome o località...`}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
          </div>

          {/* Search Button */}
          <button
            type="submit"
            className="ml-4 bg-pizzaveg hover:bg-pizzaveg-dark text-white px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:shadow-md whitespace-nowrap"
          >
            Cerca
          </button>
        </div>
      </form>
    </div>
  );
}